module.exports = __webpack_public_path__ + "img/nav-logo-responsive.ec617b16.webp";